// El dashboard del Administrador, contiene las pestañas para gestionar proyectos, usuarios, servicios, proveedores.
import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { ProjectManagementModal } from '../components/UI/ProjectManagementModal';
import { PROYECTOS_COLLECTION} from '../utils/constants'

import { 
    getAuth, createUserWithEmailAndPassword} from 'firebase/auth';
import { db, firebaseConfig } from '../firebase/config';

import { 
    collection, addDoc, query, where, getDocs, doc, onSnapshot, setDoc, Timestamp,
    runTransaction, orderBy
} from 'firebase/firestore';

import { useUser } from '../context/UserContext';
import 'react-toastify/dist/ReactToastify.css';
import { Alert} from '../components/UI/Alert'
import { ProjectsTable } from '../components/shared/ProjectsTable'

export const AdminDashboard = ({ selectedRole }) => {
    const { userData, user } = useUser();
    const [view, setView] = useState('projects');
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [managedProject, setManagedProject] = useState(null);

    const refreshData = () => {
        setLoading(true);
        const qProjects = query(collection(db, PROYECTOS_COLLECTION), orderBy("fechaApertura", "desc"));
        const unsubscribe = onSnapshot(qProjects, (snapshot) => {
            setProjects(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        return unsubscribe;
    };

    useEffect(() => {
        const unsubscribe = refreshData();
        return () => unsubscribe();
    }, []);

    return (
        <div>
            <div className="mb-6 border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    <button onClick={() => setView('projects')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'projects' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>Proyectos</button>
                    <button onClick={() => setView('users')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'users' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>Usuarios</button>
                    <button onClick={() => setView('services')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'services' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>Servicios</button>
                    <button onClick={() => setView('providers')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'providers' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>Proveedores</button>
                </nav>
            </div>
            
            {view === 'users' && <UserManagement onUserAdded={() => {}} />}
            
            {view === 'projects' && (
                <>
                    <NewProjectForm onProjectAdded={refreshData} />
                    <h2 className="text-2xl font-bold text-gray-800 my-6">Todos los Proyectos</h2>
                    {loading ? <p>Cargando tabla...</p> : <ProjectsTable projects={projects} onUpdateProject={refreshData} userRole="administrador" selectedRole={selectedRole} onManageClick={setManagedProject} />}
                </>
            )}

            {view === 'services' && <ServiceManagement />}
            {view === 'providers' && <DataManagement collectionName="proveedores" title="Proveedores" fields={['nombre', 'proveedorIdNumerico']} placeholderTexts={['Nombre del Proveedor', 'ID Numérico (ej: 01)']} />}
            
            {managedProject && 
                <ProjectManagementModal 
                    project={managedProject} 
                    onClose={() => setManagedProject(null)} 
                    onUpdate={refreshData} 
                    user={user} 
                    userData={userData} 
                    userRole="administrador" 
                />
            }

        </div>
    );
};

// componente servicios alta y consulta para el panel del administrador
const ServiceManagement = () => {
    const [services, setServices] = useState([]);
    const [newItem, setNewItem] = useState({
        nombre: '',
        servicioIdNumerico: '',
        dependencia: '',
        durationType: 'fixed',
        totalHoras: '',
        baseHoras: '',
        porUnidad: '',
        nombreUnidad: '',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        const q = query(collection(db, "servicios"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setServices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        }, (err) => {
            setError("No se pudieron cargar los servicios.");
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setNewItem(prev => ({
            ...prev,
            [name]: type === 'radio' ? value : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!newItem.nombre || !newItem.servicioIdNumerico || !newItem.dependencia) {
            setError('Nombre, ID Numérico y Dependencia son obligatorios.');
            return;
        }

        let calculoDuracion = {};
        if (newItem.durationType === 'fixed') {
            if (!newItem.totalHoras) {
                setError('Debe especificar las horas totales para duración fija.');
                return;
            }
            calculoDuracion = { totalHoras: Number(newItem.totalHoras) };
        } else {
            if (!newItem.baseHoras || !newItem.porUnidad || !newItem.nombreUnidad) {
                setError('Horas base, valor por unidad y nombre de unidad son obligatorios para duración variable.');
                return;
            }
            calculoDuracion = {
                baseHoras: Number(newItem.baseHoras),
                porUnidad: Number(newItem.porUnidad),
                nombreUnidad: newItem.nombreUnidad,
            };
        }

        try {
            await addDoc(collection(db, "servicios"), {
                nombre: newItem.nombre,
                servicioIdNumerico: newItem.servicioIdNumerico,
                dependencia: newItem.dependencia,
                calculoDuracion: calculoDuracion,
            });
            setSuccess(`¡Servicio '${newItem.nombre}' añadido con éxito!`);
            setNewItem({
                nombre: '', servicioIdNumerico: '', dependencia: '', durationType: 'fixed',
                totalHoras: '', baseHoras: '', porUnidad: '', nombreUnidad: '',
            });
        } catch (err) {
            setError(`Error al añadir el servicio: ${err.message}`);
        }
    };

    const displayDuration = (service) => {
        const calc = service.calculoDuracion;
        if (!calc) return 'N/A';
        if (calc.totalHoras) {
            return `${calc.totalHoras}h Total`;
        }
        if (calc.baseHoras !== undefined) {
            return `${calc.baseHoras}h + ${calc.porUnidad}h/${calc.nombreUnidad || 'unidad'}`;
        }
        return 'Inválido';
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg border">
                <h3 className="text-xl font-bold mb-4">Añadir Nuevo Servicio</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input type="text" name="nombre" value={newItem.nombre} onChange={handleChange} placeholder="Nombre del Servicio" className="w-full p-2 border rounded" required />
                    <input type="text" name="servicioIdNumerico" value={newItem.servicioIdNumerico} onChange={handleChange} placeholder="ID Numérico (ej: 0001)" className="w-full p-2 border rounded" required />
                    <input type="text" name="dependencia" value={newItem.dependencia} onChange={handleChange} placeholder="Dependencia" className="w-full p-2 border rounded" required />
                    
                    <fieldset className="border p-3 rounded">
                        <legend className="text-sm font-medium">Tipo de Duración</legend>
                        <div className="flex space-x-4">
                            <label><input type="radio" name="durationType" value="fixed" checked={newItem.durationType === 'fixed'} onChange={handleChange} /> Fija</label>
                            <label><input type="radio" name="durationType" value="variable" checked={newItem.durationType === 'variable'} onChange={handleChange} /> Variable</label>
                        </div>
                    </fieldset>

                    {newItem.durationType === 'fixed' && (
                        <input type="number" name="totalHoras" value={newItem.totalHoras} onChange={handleChange} placeholder="Horas Totales Estimadas" className="w-full p-2 border rounded" />
                    )}

                    {newItem.durationType === 'variable' && (
                        <div className="space-y-2 border p-3 rounded bg-gray-50">
                            <input type="number" name="baseHoras" value={newItem.baseHoras} onChange={handleChange} placeholder="Horas Base" className="w-full p-2 border rounded" />
                            <input type="number" step="0.01" name="porUnidad" value={newItem.porUnidad} onChange={handleChange} placeholder="Horas por Unidad (ej: 0.75)" className="w-full p-2 border rounded" />
                            <input type="text" name="nombreUnidad" value={newItem.nombreUnidad} onChange={handleChange} placeholder="Nombre de la Unidad (ej: punto, foto)" className="w-full p-2 border rounded" />
                        </div>
                    )}

                    <Alert message={error} type="error" onClose={() => setError('')} />
                    <Alert message={success} type="success" onClose={() => setSuccess('')} />
                    <button type="submit" className="w-full bg-[#b0ef26] hover:bg-[#9ac91e] font-bold py-2 px-4 rounded">Añadir Servicio</button>
                </form>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border">
                <h3 className="text-xl font-bold mb-4">Servicios Existentes</h3>
                <div className="overflow-y-auto max-h-96">
                    <table className="min-w-full divide-y">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-2 text-left text-xs font-medium uppercase">Nombre</th>
                                <th className="px-4 py-2 text-left text-xs font-medium uppercase">ID Num.</th>
                                <th className="px-4 py-2 text-left text-xs font-medium uppercase">Dependencia</th>
                                <th className="px-4 py-2 text-left text-xs font-medium uppercase">Duración Estimada</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y">
                            {loading ? <tr><td colSpan="4">Cargando...</td></tr> : services.map(service => (
                                <tr key={service.id}>
                                    <td className="px-4 py-2 text-sm">{service.nombre}</td>
                                    <td className="px-4 py-2 text-sm">{service.servicioIdNumerico}</td>
                                    <td className="px-4 py-2 text-sm">{service.dependencia}</td>
                                    <td className="px-4 py-2 text-sm">{displayDuration(service)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

// componente de usuarios alta para formulario en el panel del admistrador
const UserManagement = ({ onUserAdded }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nombreCompleto, setNombreCompleto] = useState('');
    const [rol, setRol] = useState('cliente');
    const [clienteIdNumerico, setClienteIdNumerico] = useState('');
    const [logoUrl, setLogoUrl] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const resetForm = () => {
        setEmail(''); setPassword(''); setNombreCompleto(''); setRol('cliente');
        setClienteIdNumerico(''); setLogoUrl('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setSuccess('');

        if (!nombreCompleto || !email || !password) {
            setError('Nombre, email y contraseña son obligatorios.');
            return;
        }
        if (rol === 'cliente' && !clienteIdNumerico) {
             setError('Para clientes, el ID Numérico es obligatorio.');
            return;
        }

        try {
            const tempApp = initializeApp(firebaseConfig, `Secondary-${new Date().getTime()}`);
            const tempAuth = getAuth(tempApp);
            const userCredential = await createUserWithEmailAndPassword(tempAuth, email, password);
            
            await setDoc(doc(db, "usuarios", userCredential.user.uid), {
                email, rol, nombreCompleto,
                clienteIdNumerico: rol === 'cliente' ? clienteIdNumerico.padStart(3, '0') : '',
                logoUrl: rol === 'cliente' ? logoUrl : '',
            });

            setSuccess(`¡Usuario ${email} con rol '${rol}' creado con éxito!`);
            resetForm();
            if (onUserAdded) onUserAdded();
        } catch (err) {
            setError(`Error al crear usuario: ${err.message}`);
        }
    };
    
    return (
        <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Crear Nuevo Usuario</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
                 <input type="text" value={nombreCompleto} onChange={e => setNombreCompleto(e.target.value)} placeholder="Nombre Completo" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                 <select value={rol} onChange={e => setRol(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm">
                    <option value="cliente">Cliente</option>
                    <option value="administrador">Administrador</option>
                    <option value="directivo">Directivo</option>
                    <option value="ecotech">Encargada Ecotech</option>
                    <option value="supervisor">Supervisor de Proyectos</option>
                    <option value="tecnico">Técnico</option>
                    <option value="finanzas">Finanzas</option>
                    <option value="practicante">Practicante</option>
                 </select>
                 <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email de Acceso" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                 <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Contraseña (mínimo 6 caracteres)" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                 {rol === 'cliente' && (
                     <>
                        <input type="text" value={clienteIdNumerico} onChange={e => setClienteIdNumerico(e.target.value)} placeholder="ID Numérico Cliente (ej: 001)" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                        <input type="text" value={logoUrl} onChange={e => setLogoUrl(e.target.value)} placeholder="URL del Logo (Opcional)" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                     </>
                 )}
                 <Alert message={error} type="error" onClose={() => setError('')} />
                 <Alert message={success} type="success" onClose={() => setSuccess('')} />
                 <button type="submit" className="w-full bg-[#b0ef26] hover:bg-[#9ac91e] text-black font-bold py-2 px-4 rounded-lg">Crear Usuario</button>
            </form>
        </div>
    );
};

const DataManagement = ({ collectionName, title, fields, placeholderTexts }) => {
    const [items, setItems] = useState([]);
    const [newItem, setNewItem] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        const q = query(collection(db, collectionName));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const itemsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setItems(itemsData);
            setLoading(false);
        }, (err) => {
            console.error(`Error fetching ${collectionName}:`, err);
            setError(`No se pudieron cargar los datos de ${title}.`);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [collectionName, title]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewItem(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (fields.some(field => !newItem[field])) {
            setError('Todos los campos son obligatorios.');
            return;
        }
        setError('');
        setSuccess('');

        try {
            await addDoc(collection(db, collectionName), newItem);
            setSuccess(`¡${title.slice(0, -1)} añadido con éxito!`);
            setNewItem({});
        } catch (err) {
            setError(`Error al añadir el nuevo ítem: ${err.message}`);
        }
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Añadir Nuevo {title.slice(0, -1)}</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {fields.map((field, index) => (
                        <div key={field}>
                            <label className="block text-sm font-medium text-gray-700 capitalize">{field.replace(/([A-Z])/g, ' $1')}</label>
                            <input 
                                type="text" 
                                name={field} 
                                value={newItem[field] || ''} 
                                onChange={handleChange}
                                placeholder={placeholderTexts[index]}
                                className="mt-1 block w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                    ))}
                    <Alert message={error} type="error" onClose={() => setError('')} />
                    <Alert message={success} type="success" onClose={() => setSuccess('')} />
                    <button type="submit" className="w-full bg-[#b0ef26] hover:bg-[#9ac91e] text-black font-bold py-2 px-4 rounded-lg">Añadir</button>
                </form>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                 <h3 className="text-xl font-bold text-gray-800 mb-4">{title} Existentes</h3>
                 <div className="overflow-y-auto max-h-96">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                {fields.map(field => <th key={field} className="px-4 py-2 text-left text-xs font-medium uppercase">{field.replace(/([A-Z])/g, ' $1')}</th>)}
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {loading ? <tr><td colSpan={fields.length}>Cargando...</td></tr> : items.map(item => (
                                <tr key={item.id}>
                                    {fields.map(field => <td key={`${item.id}-${field}`} className="px-4 py-2 whitespace-nowrap text-sm">{item[field]}</td>)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                 </div>
            </div>
        </div>
    );
};

// Forms para altas de proyectos, usuarios y servicios 
const NewProjectForm = ({ onProjectAdded }) => {
    const [formData, setFormData] = useState({
        clienteId: '',
        servicioId: '',
        proveedorId: '',
        comentariosApertura: '',
        fechaApertura: new Date().toISOString().split('T')[0],
        precioCotizacionCliente: '',
        costoProveedor: '',
        cotizacionClienteRef: '',
        poClienteRef: '',
        cotizacionProveedorRef: '',
        cantidadUnidades: 1,
    });

    const [selectedService, setSelectedService] = useState(null);
    const formRef = React.useRef(null);
    const [collections, setCollections] = useState({ clientes: [], servicios: [], proveedores: [] });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const isInternalProvider = collections.proveedores.find(p => p.id === formData.proveedorId)?.nombre.toLowerCase().trim() === "ecologia y asesoria ambiental";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [clientesSnap, serviciosSnap, proveedoresSnap] = await Promise.all([
                    getDocs(query(collection(db, "usuarios"), where("rol", "==", "cliente"))),
                    getDocs(collection(db, "servicios")),
                    getDocs(collection(db, "proveedores"))
                ]);
                const sortByName = (a, b) => (a.nombreCompleto || a.nombre).localeCompare(b.nombreCompleto || b.nombre);
                setCollections({
                    clientes: clientesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort(sortByName),
                    servicios: serviciosSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort(sortByName),
                    proveedores: proveedoresSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort(sortByName)
                });
            } catch (e) {
                setError("Error al cargar datos maestros.");
            }
        };
        fetchData();
    }, []);
    
    useEffect(() => {
        if (isInternalProvider) {
            setFormData(prev => ({ ...prev, costoProveedor: '0' }));
        }
    }, [formData.proveedorId, isInternalProvider]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === "servicioId") {
            const service = collections.servicios.find(s => s.id === value);
            setSelectedService(service);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.clienteId || !formData.servicioId || !formData.proveedorId) {
            setError('Cliente, Servicio y Proveedor son obligatorios.');
            return;
        }
        setLoading(true);
        setError('');

        try {
            let horasEstimadas = 0;
            if (selectedService && selectedService.calculoDuracion) {
                if (selectedService.calculoDuracion.totalHoras) {
                    horasEstimadas = selectedService.calculoDuracion.totalHoras;
                } else if (selectedService.calculoDuracion.baseHoras !== undefined) {
                    const base = selectedService.calculoDuracion.baseHoras || 0;
                    const porUnidad = selectedService.calculoDuracion.porUnidad || 0;
                    const cantidad = Number(formData.cantidadUnidades) || 1;
                    horasEstimadas = base + (porUnidad * cantidad);
                }
            }

            const anioActual = new Date(formData.fechaApertura).getFullYear();
            const contadorRef = doc(db, "contadores", `proyectos_${anioActual}`);
            const nuevoConsecutivo = await runTransaction(db, async (transaction) => {
                const contadorDoc = await transaction.get(contadorRef);
                const nuevoValor = (contadorDoc.exists() ? contadorDoc.data().consecutivo : 0) + 1;
                transaction.set(contadorRef, { consecutivo: nuevoValor }, { merge: true });
                return nuevoValor;
            });
            
            const ultimosDosDigitosAnio = anioActual.toString().slice(-2);
            const consecutivoFormateado = nuevoConsecutivo.toString().padStart(3, '0');
            const cliente = collections.clientes.find(c => c.id === formData.clienteId);
            const servicio = collections.servicios.find(s => s.id === formData.servicioId);
            const proveedor = collections.proveedores.find(p => p.id === formData.proveedorId);
            const npu = `${cliente.clienteIdNumerico}-${servicio.servicioIdNumerico}-${proveedor.proveedorIdNumerico}-${consecutivoFormateado}${ultimosDosDigitosAnio}`;

            await addDoc(collection(db, PROYECTOS_COLLECTION), {
                npu: npu,
                clienteId: formData.clienteId,
                clienteNombre: cliente.nombreCompleto,
                servicioId: formData.servicioId,
                servicioNombre: servicio.nombre,
                proveedorId: formData.proveedorId,
                proveedorNombre: proveedor.nombre,
                fechaApertura: Timestamp.fromDate(new Date(formData.fechaApertura)),
                estado: formData.poClienteRef ? 'Activo' : 'Cotización',
                prioridad: "1 - Normal",
                dependencia: servicio.dependencia || 'Sin Dependencia',
                precioCotizacionCliente: Number(formData.precioCotizacionCliente) || 0,
                costoProveedor: Number(formData.costoProveedor) || 0,
                horasEstimadas: horasEstimadas,
                horasRegistradas: 0,
                facturasClienteIds: [],
                facturasProveedorIds: [],
                faseFacturacion: 'N/A',
                cotizacionClienteRef: formData.cotizacionClienteRef,
                poClienteRef: formData.poClienteRef,
                cotizacionProveedorRef: formData.cotizacionProveedorRef,
                poProveedor: isInternalProvider ? "N/A" : npu.slice(-8),
                cantidadUnidades: (selectedService?.calculoDuracion?.porUnidad) ? Number(formData.cantidadUnidades) : null,
                asignadoTecnicosIds: [],
                comentariosApertura: formData.comentariosApertura,
                fechaAsignacionTecnico: null,
                fechaEntregaInterna: null,
                notasSupervisor: "",
                fechaFinTecnicoReal: null,
            });
            
            setFormData({
                clienteId: '', servicioId: '', proveedorId: '', comentariosApertura: '',
                fechaApertura: new Date().toISOString().split('T')[0],
                precioCotizacionCliente: '', costoProveedor: '', cotizacionClienteRef: '',
                poClienteRef: '', cotizacionProveedorRef: '', cantidadUnidades: 1,
            });
            setSelectedService(null);
            formRef.current.reset();
            if (onProjectAdded) onProjectAdded();

        } catch (err) {
            console.error("Error al crear proyecto:", err);
            setError(`Ocurrió un error: ${err.message}`);
        }
        setLoading(false);
    };

    const showUnitsInput = selectedService && selectedService.calculoDuracion && selectedService.calculoDuracion.porUnidad;

    return (
        <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-200 mb-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Crear Nuevo Proyecto</h3>
            <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Fecha de Apertura</label>
                        <input type="date" name="fechaApertura" value={formData.fechaApertura} onChange={handleChange} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"/>
                    </div>
                     <select name="clienteId" value={formData.clienteId} onChange={handleChange} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm">
                        <option value="">Seleccione un Cliente</option>
                        {collections.clientes.map(c => <option key={c.id} value={c.id}>{c.nombreCompleto}</option>)}
                     </select>
                     <select name="servicioId" value={formData.servicioId} onChange={handleChange} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm">
                        <option value="">Seleccione un Proyecto/Servicio</option>
                        {collections.servicios.map(s => <option key={s.id} value={s.id}>{s.nombre}</option>)}
                     </select>
                     <select name="proveedorId" value={formData.proveedorId} onChange={handleChange} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm">
                        <option value="">Seleccione un Proveedor</option>
                        {collections.proveedores.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                     </select>
                    <textarea name="comentariosApertura" value={formData.comentariosApertura} onChange={handleChange} placeholder="Comentarios de apertura" className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm"></textarea>
                    {showUnitsInput && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 capitalize">
                                Cantidad de {selectedService.calculoDuracion.nombreUnidad || 'Unidades'}
                            </label>
                            <input type="number" name="cantidadUnidades" value={formData.cantidadUnidades} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border rounded-md"/>
                        </div>
                    )}                
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 border-t pt-6">
                    <div className="space-y-4">
                        <h4 className="font-semibold text-gray-700">Información del Cliente</h4>
                        <input type="number" name="precioCotizacionCliente" value={formData.precioCotizacionCliente} onChange={handleChange} placeholder="Precio Cotización (con IVA)" className="mt-1 block w-full px-3 py-2 border rounded-md"/>
                        <input type="text" name="cotizacionClienteRef" value={formData.cotizacionClienteRef} onChange={handleChange} placeholder="Nº o Referencia de Cotización" className="mt-1 block w-full px-3 py-2 border rounded-md"/>
                        <input type="text" name="poClienteRef" value={formData.poClienteRef} onChange={handleChange} placeholder="Nº de Orden de Compra (PO)" className="mt-1 block w-full px-3 py-2 border rounded-md"/>
                    </div>
                    <div className="space-y-4">
                        <h4 className="font-semibold text-gray-700">Información del Proveedor</h4>
                        <input type="number" name="costoProveedor" value={formData.costoProveedor} onChange={handleChange} placeholder="Costo (con IVA)" disabled={isInternalProvider} className="mt-1 block w-full px-3 py-2 border rounded-md disabled:bg-gray-100"/>
                        <input type="text" name="cotizacionProveedorRef" value={formData.cotizacionProveedorRef} onChange={handleChange} placeholder="Nº o Ref. de Cotización Proveedor" disabled={isInternalProvider} className="mt-1 block w-full px-3 py-2 border rounded-md"/>
                    </div>
                </div>

                <Alert message={error} type="error" onClose={() => setError('')} />
                <button type="submit" disabled={loading} className="w-full bg-[#b0ef26] hover:bg-[#9ac91e] text-black font-bold py-2 px-4 rounded-lg disabled:bg-gray-400">
                    {loading ? 'Creando...' : 'Crear Proyecto y Generar NPU'}
                </button>
            </form>
        </div>
    );
};